import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { Chat } from '../messenger.interface';
import { ConversationStateModel } from '../../../store/store-models';
import { getConversationUnreadCount } from '../utils';
import { UserDataModel } from '@modules/auth';

@Component({
  selector: 'app-chat-list-item',
  templateUrl: './chat-list-item.component.html',
  styleUrls: ['./chat-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatListItemComponent {
  @Input() chat: Chat;
  @Input() mainParticipantUser: UserDataModel;
  @Input() conversation: ConversationStateModel;

  getConversationUnreadCount = getConversationUnreadCount;
}
